export const GIFT_FORM_STATIC_KEY = 'giftForm'
export default GIFT_FORM_STATIC_KEY
